import { ApiKeysManager } from '../../components/ApiKeys/ApiKeysManager';
import { PageHeader } from '../../components/Common/PageHeader';

export function AccountApiKeysPage() {
  return (
    <>
      <PageHeader title="API Keys" subtitle="Manage scoped API keys for programmatic access." />
      <ApiKeysManager />
    </>
  );
}
